<template>
  <div :class="['w-full', inline ? 'flex flex-row gap-4' : 'flex flex-col gap-2']">
    <div
      v-for="option in options"
      :key="option.value"
      :class="['relative', inline ? 'flex-1' : 'w-full']"
    >
      <button
        type="button"
        :class="[
          'w-full',
          'flex items-center justify-between rounded-2xl border px-5 py-3 text-base font-semibold transition focus:outline-none',
          value === option.value
            ? 'border-primary text-primary bg-orange-50 shadow-lg'
            : 'border-gray-200 text-gray-700 bg-white',
          'transition'
        ]"
        @click="$emit('input', option.value)"
      >
        <span>{{ option.label }}</span>
        <span v-if="value === option.value" class="flex items-center justify-center ml-2">
          <span class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary">
            <i class="bx bx-check text-white text-base"></i>
          </span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CuRadioGroup",
  props: {
    value: [String, Number],
    options: {
      type: Array,
      required: true
    },
    inline: {
      type: Boolean,
      default: false
    }
  }
}
</script>
